import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, experienceLevelsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, experienceLevelsActions);

export default slice.reducer;
